import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createBlock(_component_MultiSelect, {
    filter: true,
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
    options: _ctx.options,
    optionLabel: "LABEL",
    optionValue: "ID",
    placeholder: _ctx.$t('choose_dropdown'),
    display: "chip",
    filterPlaceholder: _ctx.$t('search'),
    class: "p-mb-2",
    showClear: _ctx.clearable,
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.select($event[1]))),
    selectionLimit: _ctx.limit
  }, null, 8, ["modelValue", "options", "placeholder", "filterPlaceholder", "showClear", "selectionLimit"]))
}